import React, { useCallback, useState } from "react";
import { Field, Form } from "react-final-form";
import { Button, Modal, ModalBody, ModalHeader } from "reactstrap";
import { DetailedErrorAlert } from "../../../components/DetailedErrorAlert";
import { LoadingButton } from "../../../components/LoadingButton";
import { api, extractErrorMessage } from "../../../util/api";
import { snakifyKeys } from "../../../util/helpers";
import { AdminOptionableInput } from "../../components/inputs/AdministrateSelectInput";

export const AddPortalLabModal = ({ portal, onAdd, ...rest }) => {
  const [open, setOpen] = useState(false);
  const [error, setError] = useState(null);

  const toggleModal = () => setOpen((x) => !x);

  const handleCreate = useCallback(
    async (values) => {
      setError(null);
      try {
        const { data } = await api.post(`/admin/benefit_management_portals/${portal.id}/labs`, snakifyKeys(values));

        if (data) {
          onAdd(data);
        }

        setOpen(false);
      } catch (err) {
        setError(extractErrorMessage(err));
      }
    },
    [onAdd, portal.id]
  );

  return (
    <>
      <Button onClick={toggleModal} {...rest}>
        Add Lab
      </Button>

      <Modal isOpen={open} toggle={toggleModal} size="lg">
        <ModalHeader toggle={toggleModal}>Add Lab(s)</ModalHeader>

        <ModalBody>
          <DetailedErrorAlert error={error} />

          <Form onSubmit={handleCreate}>
            {({ handleSubmit, submitting }) => {
              return (
                <>
                  <Field
                    component={AdminOptionableInput}
                    resource="labs"
                    label="Name(s)"
                    name="labIds"
                    extraParams={{ hide_discarded: true, show_all_labs: true }}
                    isMulti
                    required
                  />
                  <LoadingButton loading={submitting} onClick={handleSubmit} disabled={submitting}>
                    Save
                  </LoadingButton>
                </>
              );
            }}
          </Form>
        </ModalBody>
      </Modal>
    </>
  );
};
